(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["multi-buy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('multi-buy-offer')) {
    class MultiBuyOffer extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.quantityInput = this.dataset.quantityInputId ? document.getElementById(this.dataset.quantityInputId) : null;

        if (this.quantityInput) {
          this.quantityInput.addEventListener('input', () => this.updatePdpState(), { signal: this.abortController.signal });
          this.quantityInput.addEventListener('change', () => this.updatePdpState(), { signal: this.abortController.signal });
          this.updatePdpState();
        }

        this.addEventListener('click', (event) => this.handleClick(event), { signal: this.abortController.signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      get tiers() {
        return Array.from(this.querySelectorAll('[data-tier-quantity]'))
          .map((row) => ({
            row,
            quantity: Number.parseInt(row.dataset.tierQuantity, 10),
            display: row.dataset.tierDisplay || ''
          }))
          .filter((tier) => Number.isFinite(tier.quantity) && tier.quantity > 0)
          .sort((a, b) => a.quantity - b.quantity);
      }

      replaceTokens(template, values) {
        return Object.entries(values).reduce((result, [key, value]) => result.replaceAll(`%${key}%`, String(value)), template || '');
      }

      savingsText(display) {
        return display.trim().replace(/^save\s+/i, 'save ');
      }

      updatePdpState() {
        if (this.dataset.context !== 'pdp' || !this.quantityInput) return;

        const quantity = Number.parseInt(this.quantityInput.value, 10) || 1;
        const tiers = this.tiers;
        const reached = tiers.filter((tier) => quantity >= tier.quantity);
        const next = tiers.find((tier) => tier.quantity > quantity);

        tiers.forEach((tier) => tier.row.classList.toggle('is-reached', quantity >= tier.quantity));

        const progress = this.querySelector('.multi-buy__progress');
        if (!progress) return;

        if (!next) {
          progress.textContent = this.dataset.reached || '';
          return;
        }

        const missing = next.quantity - quantity;
        const template = missing === 1 ? this.dataset.unlockOne : this.dataset.unlockMany;
        progress.textContent = this.replaceTokens(template, { count: missing, quantity: next.quantity });
      }

      handleClick(event) {
        const color = event.target.closest('[data-multi-buy-color]');
        if (color && this.contains(color)) {
          this.selectColor(color);
          return;
        }
        this.addToNextTier(event);
      }

      selectColor(color) {
        this.querySelectorAll('[data-multi-buy-color]').forEach((button) => {
          const selected = button === color;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-checked', String(selected));
        });
        this.dataset.selectedVariantId = color.dataset.variantId || this.dataset.currentVariantId || '';
      }

      async addToNextTier(event) {
        const button = event.target.closest('[data-multi-buy-add]');
        if (!button || !this.contains(button)) return;

        const lineKey = this.dataset.lineKey;
        const addCount = Number.parseInt(button.dataset.addCount, 10);
        if (!lineKey || !Number.isFinite(addCount) || addCount < 1) return;

        const selectedVariantId = this.dataset.selectedVariantId;
        const currentVariantId = this.dataset.currentVariantId;
        if (selectedVariantId && selectedVariantId !== currentVariantId) {
          button.disabled = true;
          try {
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({ items: [{ id: Number(selectedVariantId), quantity: addCount }] })
            });
            if (!response.ok) throw new Error('Unable to add the selected color.');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } catch (error) {
            console.error(error);
            button.disabled = false;
          }
          return;
        }

        const input = Array.from(document.querySelectorAll('input[data-line-key]')).find((candidate) => candidate.dataset.lineKey === lineKey);
        if (!input) return;

        button.disabled = true;
        input.value = (Number.parseInt(input.value, 10) || 0) + addCount;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    customElements.define('multi-buy-offer', MultiBuyOffer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-back-to-top"] && !Shopify.designMode) return;
  try {
    class YGBackToTop extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      this.visible = false;
      this.lastScroll = window.scrollY;
      this.render();
    }

    connectedCallback() {
      this.shadowRoot.querySelector('.back-to-top-btn').addEventListener('click', this.handleClick.bind(this));
      window.addEventListener('scroll', this.handleScroll.bind(this));
    }

    disconnectedCallback() {
      this.shadowRoot.querySelector('.back-to-top-btn').removeEventListener('click', this.handleClick.bind(this));
      window.removeEventListener('scroll', this.handleScroll.bind(this));
    }

    handleClick() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    handleScroll() {
      const currentScroll = window.scrollY;
      const goingUp = currentScroll < this.lastScroll;
      const over600 = currentScroll > 600;
      if (over600 && goingUp) {
        this.show();
      } else {
        this.hide();
      }
      this.lastScroll = currentScroll;
    }

    show() {
      if (!this.visible) {
        this.visible = true;
        this.shadowRoot.querySelector('.back-to-top-btn').classList.add('visible');
      }
    }

    hide() {
      if (this.visible) {
        this.visible = false;
        this.shadowRoot.querySelector('.back-to-top-btn').classList.remove('visible');
      }
    }

    render() {
      this.shadowRoot.innerHTML = `
      <style>
        .back-to-top-btn {
          position: fixed;
          right: 15px;
          bottom: calc(var(--yg-product-btn,0px) + 100px);
          width: 40px;
          height: 40px;
          background: #fff;
          border: 1px solid #f0f0f0;
          border-radius: 50%;
          box-shadow: 0 2px 8px rgba(0,0,0,0.10);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          opacity: 0;
          visibility: hidden;
          pointer-events: none;
          transition: opacity 0.3s, visibility 0.3s, bottom 0.3s;
          z-index: 9999;
        }
        .back-to-top-btn.visible {
          opacity: 1;
          visibility: visible;
          pointer-events: auto;
        }
        .back-to-top-btn svg {
          display: block;
          margin: 0 auto;
        }
      </style>
      <div class="back-to-top-btn" aria-label="Back to top" tabindex="0">
        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.77293 2.1213L1.06066 5.83365L0 4.773L4.77293 0L9.54593 4.773L8.48528 5.83365L4.77293 2.1213Z" fill="#262524"/>
        </svg>
      </div>
    `;
    }
  }

  if (!window.customElements.get('yg-back-to-top')) {
    window.customElements.define('yg-back-to-top', YGBackToTop);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-image"] && !Shopify.designMode) return;
  try {
    class YGImage extends YGImageLoader {
    constructor() {
      super();
    }
    connectedCallback() {
      this.loaderImg();
    }
    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        // 安全检查，确保 YGUtils 已加载
        if (this.getYGImageLoader) {
          this.getYGImageLoader().observe(img);
        } else {
          console.warn('YGUtils 未加载，使用备用图片加载方式');
          // 备用方案：直接设置图片源
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-popup"] && !Shopify.designMode) return;
  try {
    class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.closePopup = this.closePopup.bind(this);
      this.openPopup = this.openPopup.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.closePopup);
      document.addEventListener('YG:openPopup', (e) => this.openPopup(e));
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.closePopup);
      document.removeEventListener('YG:openPopup', (e) => this.openPopup(e));
    }

    openPopup(e) {
      const { popupTemplate, popupClass, closeBtnClass } = e.detail || {};
      this.popupTemplate = popupTemplate;
      this.popupClass = popupClass;
      this.closeBtnClass = closeBtnClass;
      
      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }
      // popupTemplate：需要替换的元素
      this.querySelector('.yg-popup-box-close').classList.add(`${closeBtnClass}`)
      this.classList.add(`${popupClass}`)
      this.querySelector('.yg-popup-box-content-inner').innerHTML = popupTemplate.innerHTML;
      document.querySelector('body').style.overflow = 'hidden';
      this.style.display = 'flex';
    }

    closePopup(e) {
      const closeBtn = e.target.closest('.yg-popup-box-close');
      const popupBox = e.target.closest('.yg-popup-box');
      if (closeBtn || (popupBox && e.target === popupBox)) {
        this.style.display = 'none';
        this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
        document.querySelector('body').style.overflow = 'auto';
        this.querySelector('.yg-popup-box-close').classList.remove(`${closeBtnClass}`)
        this.classList.remove(`${popupClass}`)
      }
    } 
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    get template() {
      return this.querySelector('template');
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick() {
      this.dispatchEvent(
        new CustomEvent('YG:openPopup', {
          bubbles: true,
          detail: {
            popupTemplate: this.template,
          },
        })
      );
    }
  }

  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-video"] && !Shopify.designMode) return;
  try {
    class YGVideo extends YGVideoLoader {
    constructor() {
      super();
      this.playVideoClick = this.playVideo.bind(this);
      this.autoplay = this.getAttribute('data-autoplay');
      this.popup = this.getAttribute('data-popup');
      this.type = this.getAttribute('data-type');
    }

    get videoContainer() {
      return this.querySelector('.yg-video-iframe-container');
    }

    get image() {
      return this.querySelector('.yg-video-placeholder');
    }

    get template() {
      return this.querySelector('template');
    }

    get playVideoButton() {
      return this.querySelector('.yg-play-video');
    }

    connectedCallback() {
      this.playVideoButton?.addEventListener('click', this.playVideoClick);
      if (this.autoplay == 'true' && this.popup == 'false') {
        this.getYGVideoLoader().observe(this);
      }
    }

    playVideo() {
      if (this.popup == 'true') {
        this.dispatchEvent(
          new CustomEvent('YG:openPopup', {
            bubbles: true,
            detail: {
              popupTemplate: this.template,
            },
          })
        );

        return;
      }

      this.image?.classList.add('hide');
      this.playVideoButton?.classList.add('hide');

      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        
        this.videoContainer.classList.remove('hide');
        videos.forEach(video => {
          video.play();
        });

        return;
      }

      this.appendChild(this.template?.content.cloneNode(true));
    }

    pauseVideo() {
      this.image?.classList.remove('hide');
      this.playVideoButton?.classList.remove('hide');
      
      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        this.videoContainer.classList.add('hide');

        videos.forEach(video => {
          video.pause();
          video.currentTime = 0;
        });
      } else {
        this.videoContainer?.remove();
      }
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
